import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

function getGACustomDimensions(props) {
  const { currTab = "", app_id = "", upload_for } = props;
  return {
    dimension1: currTab,
    // add other custom dimensions in this object like shown below
    dimension2: upload_for,
    dimension3: app_id,
  };
}

const useAnalyticsEventTracker = (category = "", app_id = "") => {
  const location = useLocation();
  const currentTab = location.pathname.split("/");
  const eventTracker = (action = "", label = "", upload_for) => {
    ReactGA.set(
      getGACustomDimensions({
        currTab: currentTab[1],
        app_id,
        upload_for,
      })
    );
    ReactGA.event({ category, action, label });
  };
  return eventTracker;
};
export default useAnalyticsEventTracker;
